import { gql } from '@apollo/client';

export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotification($id: ID!) {
    deleteNotification(notificationId: $id) {
      success
    }
  }
`;
